import { notifyError } from 'shared/Toast/Toast';

export const handleDevicePermissionChange = (payload: {
  name: 'microphone' | 'camera';
  state: 'denied' | 'granted' | 'prompt';
}) => {
  payload.state === 'denied' && notifyError(`Please allow ${payload.name} permission to continue.`);
};
